import { NetworkProfile } from './network-profile';
import { StaticRoute } from './static-route';
export class FleetConfiguration {
    public name: string = '';
    public id: string = '';
    public vcenterInstanceId: string = '';
    public vcenterName: string = '';
    public dataStoreId: string = '';
    public dataStoreName: string = '';
    public resourcePoolId: string = '';
    public resourcePoolName: string = '';
    public clusterId?: string = '';
    public networkProfiles: Array<NetworkProfile> = new Array<NetworkProfile>();
    public staticRoutes:Array<StaticRoute> = new Array<StaticRoute>();
    public displayVcenterName: string = '';
    public displayResourcePoolName: string = '';
    public displayDataStoreName: string = '';
    public smEnabledStatus: string;
    public smEnabledMessage: string;
    public convert(){
        
    }
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/model/fleet-configuration.ts